import * as React from 'react';

export interface EliminationProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const Elimination: React.FunctionComponent<React.PropsWithChildren<EliminationProps>> = ({
    height,
    width,
    ...rest
}): any => (
    <img
        width={height}
        height={width}
        alt="E"
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAt1BMVEUAAAj0gwD5mADgegAAiv/5mAD5mAAA//8AVar2hQDXeQD5mAD5mQCAVQD4mAD4mADMdgD2hQDxgwD2hQD4mADpjwD3lwD4mAD0lQCuZwD5mQDtjgD2hQD3lwD2hQDjjQBVOQD2hQD4mAD3lwD0lQD3mAD4mQDegAD4mAD6mADsfwDykwD2hQDuiQD0kwDylgD2hQD1hAD4lgD0hAD1mAD2lwD2lQD2hQD5mAD5mADylgD5lwD3mAC6N+IBAAAAPXRSTlMDhs8gA8jGAwPhEq/BBrLEDt5I6ZEhiLhBCcwt5ITvGgTFlYFdoLYXjL0nO6U0S1DX1pyMWHhSrKipTnh5HOTIsgAAASZJREFUeF51kdl2gyAQQKdmEIIotnW3NjaarU3TrN3//7sKKNGX3gfOmbkwzAB04Oy7+tpsPqvdisKIsCpk6h2PXiqdKh/yL9Jdcx8UfhgR8cqgoyVpjNCD8ZK8d1FGFgxG1AsnM/XlUm/gE8MKAGggfQBMSKwCdjM1bPWmWRHpJcFePCo+dLfYCIQ3yaETtyFj/WWlc4Yk9a3gYKHEA88DKyac87oTcwFibsX0QfFsIrzIsdgfDvte/MpxqZpSymyp/y4PVLuhFSEisr7dVg24tgM+KU7YDVhfn+R0b9jqyWP9JJCLwJy+M+i/8AOZm28iC4QBlScZaNjZCVZXhZMl2fURZqRoSkoRKS2bws2GAnkkHTe6/ESuI9Y5jMHW2wghgtYm/gBbNhe5pq8d6gAAAABJRU5ErkJggg=="
        {...rest}
    />
);

export default Elimination;
